import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import {
    FiscalYearGridObject,
    FiscalYearObject,
} from '@libs/types/src/mado/object-type/organization/fiscal-year.object';
import { filterFrag } from './types/filter.types';
import { FiscalYearCreateInput } from '@libs/types/src/mado/input-type/organization/fiscal-year.create-input';
import { FiscalYearUpdateInput } from '@libs/types/src/mado/input-type/organization/fiscal-year.update-input';

@Injectable({ providedIn: 'root' })
export class FiscalYearGqlService extends GqlServiceV2 {

    public getFiscalYears(input: GridInput | null, frag: string): Promise<FiscalYearGridObject> {
        return this.query<FiscalYearGridObject>(
            `
                query($input: GridInput!) {
                    fiscalYear {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createFiscalYear(input: FiscalYearCreateInput, frag: string) {
        return this.mutate<FiscalYearObject>(
            `
                mutation($input: FiscalYearCreateInput!) {
                    fiscalYear {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateFiscalYear(input: FiscalYearUpdateInput, frag: string) {
        return this.mutate<FiscalYearObject>(
            `
                mutation($input: FiscalYearUpdateInput!) {
                    fiscalYear {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }
}
